<div
  class="visionboard-item-selection-dialog-container"
  cdkScrollable
>
  <!-- Close dialog button -->
  <button
    mat-icon-button
    class="close-button"
    (click)="onCloseButtonClick()"
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
  <div class="search-and-filters">
    <div class="search-and-filter-button">
      <app-visionboard-item-search-bar class="search"></app-visionboard-item-search-bar>
      <app-search-filters
        class="filters"
        height="36px"
        [showLabel]="!mobile"
      ></app-search-filters>
    </div>

    <app-visionboard-item-filter-scroller (onLoaded)="onScrollerLoaded()"></app-visionboard-item-filter-scroller>
  </div>

  <app-visionboard-item-search-results
    class="results"
    disableDrag="true"
    (itemClicked)="onItemClicked($event)"
    (paged)="onItemResultsPaged()"
    [allowDupes]="false"
    [forceVisionboardItemAddRemoveButton]="data.forceVisionboardItemAddRemoveButton"
    source="Category View Search Results"
  ></app-visionboard-item-search-results>
</div>
